import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  email: "",
  phone: "",
  address: "",
  latitude: "",
  longitude: "",
  dc_id: "",
  dc_custom_id: "",
  country: "",
  city: "",
  postalCode: "",
  countryCode: "us",
};

const customerFormSlice = createSlice({
  name: "customerForm",
  initialState,
  reducers: {
    setCustomerForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetCustomerForm: (state) => {
      return { ...initialState, countryCode: state.countryCode };
    },
  },
});

export const { setCustomerForm, resetCustomerForm } = customerFormSlice.actions;
export default customerFormSlice.reducer;
